module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3-bbac669a5d5498d8ab79923152af88c5.jpg";